var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"image is-24x24",attrs:{"alt":"avatar image","src":_vm.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }